import { render, staticRenderFns } from "./notification-header-list.vue?vue&type=template&id=642e8e77&scoped=true"
import script from "./notification-header-list.vue?vue&type=script&lang=js"
export * from "./notification-header-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e8e77",
  null
  
)

export default component.exports